export default "__VITE_ASSET__DFgTUYx0__"